import { IonButton, IonButtons, IonIcon, IonModal, IonText, IonToolbar } from "@ionic/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { xMarkIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ModalCoreValuesAccuracyExplainer() {
	const { t } = useTranslation();
	const modalRef = useRef<HTMLIonModalElement>(null);
	const modal = useSelectorModalStore.use.coreValuesAccuracyExplainer();
	const present = useSelectorModalStore.use.present();
	const dismiss = useSelectorModalStore.use.dismiss();

	return (
		<IonModal
			ref={modalRef}
			isOpen={modal.isOpen}
			onWillPresent={() => {
				present("coreValuesAccuracyExplainer");
			}}
			onWillDismiss={() => {
				dismiss("coreValuesAccuracyExplainer");
			}}
			initialBreakpoint={1}
			breakpoints={[0, 1]}
			className="ion-min-h-[600px] ion-rounded-4xl ion-h-min"
		>
			<IonToolbar className="ion-bg-transparent pt-2">
				<IonButtons slot="end">
					<IonButton
						onClick={() => dismiss("coreValuesAccuracyExplainer")}
						shape="round"
						className="part-icon:m-0 part-icon:size-5 part-native:size-10 part-native:min-h-0 part-native:rounded-full part-native:bg-brown-300 part-native:p-1 part-native:text-xs part-native:text-brown-600 min-h-0"
					>
						<IonIcon icon={xMarkIcon} />
					</IonButton>
				</IonButtons>
			</IonToolbar>

			<div className="flex flex-col gap-2 px-4">
				<IonText className="text-brown-700 text-2xl font-bold">
					{t("modal.compile-core-values.accuracy-explainer.title")}
				</IonText>
				<IonText className="text-brown-600">
					{t("modal.compile-core-values.accuracy-explainer.description")}
				</IonText>
			</div>
		</IonModal>
	);
}
